
export class ErDashBoardData {
  static readonly type = '[ErDashBoardData] ErDashBoardData';

  constructor(public payload: any) {
  }
}